export default __webpack_public_path__ + "static/media/731.c9bee742.png";